import {
  changeTextLineIDsObjectForClient,
  prepareACDItemForApi
} from "./apiUtils";
import { debounce } from "debounce";

export async function getArticlesApi(issueID, isPdf) {
  const uri =
    process.env.REACT_APP_API_ROOT +
    (isPdf ? "pdf_books/" : "web_content_books/") +
    issueID +
    "/articles";

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  for (let i = 0; i < data.length; i++) {
    try {
      let titleTextLineIDs = changeTextLineIDsObjectForClient(
        data[i].title_component.text_line_ids
      );
      data[i].title_component.textLineIDs = titleTextLineIDs;

      if (data[i].title_component.ordered_text_line_ids != null) {
        data[i].title_component.orderedTextLineIDs = data[
          i
        ].title_component.ordered_text_line_ids.map(aTextLineID =>
          changeTextLineIDsObjectForClient(aTextLineID)
        );
      }
    } catch (e) {}
  }

  return data;
}

export async function getAnArticleApi(articleID) {
  const uri = process.env.REACT_APP_API_ROOT + "articles/" + articleID;

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  try {
    let titleTextLineIDs = changeTextLineIDsObjectForClient(
      data.title_component.text_line_ids
    );
    data.title_component.textLineIDs = titleTextLineIDs;

    if (data.title_component.ordered_text_line_ids != null) {
      data.title_component.orderedTextLineIDs = data.title_component.ordered_text_line_ids.map(
        aTextLineID => changeTextLineIDsObjectForClient(aTextLineID)
      );
    }
  } catch (e) {}

  return data;
}

export async function getArticleComponentsApi(articleID) {
  const uri =
    process.env.REACT_APP_API_ROOT + "articles/" + articleID + "/components";

  let response = await fetch(uri);

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function updateArticlesMetaApi(issueID, isPdf, metaData) {
  const uri =
    process.env.REACT_APP_API_ROOT +
    (isPdf ? "pdf_books/" : "web_content_books/") +
    issueID +
    "/update_articles_metadata";

  let response = await fetch(uri, {
    headers: { "Content-Type": "application/json" },
    method: "PUT",
    body: JSON.stringify(metaData)
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function saveTocApi(issueID, tocs) {
  const uri =
    process.env.REACT_APP_API_ROOT + "pdf_books/" + issueID + "/upsert_toc";

  let response = await fetch(uri, {
    headers: { "Content-Type": "application/json" },
    method: "POST",
    body: JSON.stringify(tocs)
  });

  if (!response.ok) {
    try {
      let data = await response.json();
      throw Error(data.message);
    } catch (e) {
      throw e;
    }
  }

  let data = await response.json();

  return data;
}

export async function saveWebTocApi(issueID, tocs) {
  const uri =
    process.env.REACT_APP_API_ROOT +
    "web_content_books/" +
    issueID +
    "/upsert_toc";

  let response = await fetch(uri, {
    headers: { "Content-Type": "application/json" },
    method: "POST",
    body: JSON.stringify(tocs)
  });

  if (!response.ok) {
    throw Error(response.statusText);
  }

  let data = await response.json();

  return data;
}

export async function convertAnfApi(articleID) {
  const uri =
    process.env.REACT_APP_API_ROOT + "articles/" + articleID + "/convert_anf";

  await fetch(uri, {
    method: "GET"
  })
    .then(response => response.blob())
    .then(blob => {
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = url;
      a.download = articleID + ".zip";
      document.body.appendChild(a);
      a.click();
      a.remove();
    });
}

export async function confirmArticleApi(articleID) {
  const uri = process.env.REACT_APP_API_ROOT + "articles/" + articleID;

  let response = await fetch(uri, {
    headers: { "Content-Type": "application/json" },
    method: "PUT",
    body: JSON.stringify({ is_dirty: false, check: true })
  });

  if (!response.ok) {
    try {
      let data = await response.json();
      throw Error(data.message);
    } catch (e) {
      throw e;
    }
  }

  let data = await response.json();

  return data;
}

export async function convertDocxApi(articleID, htmlText) {
  const uri = process.env.REACT_APP_API_ROOT + "articles/export_html_as_docx";

  await fetch(uri, {
    headers: { "Content-Type": "application/json" },
    method: "POST",
    body: JSON.stringify({ html_text: htmlText })
  })
    .then(response => response.blob())
    .then(blob => {
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = url;
      a.download = articleID + ".docx";
      document.body.appendChild(a);
      a.click();
      a.remove();
    });
}

export const saveArticleContentApi = debounce(
  delayedSaveArticleContentApi,
  1500
);

export async function delayedSaveArticleContentApi(
  articleID,
  metaDict,
  contentACDItemList,
  toast
) {
  const titleID = articleID + "-TITLE";
  const pTitleItem = prepareACDItemForApi(metaDict[titleID]);

  const subtitleID = articleID + "-SUBTITLE";
  const pSubtitleItem = prepareACDItemForApi(metaDict[subtitleID]);

  const authorID = articleID + "-CONTRIBUTOR";
  const pAuthorItem = prepareACDItemForApi(metaDict[authorID]);

  const introID = articleID + "-INTRO";
  const pIntroItem = prepareACDItemForApi(metaDict[introID]);

  const mainArtworkID = articleID + "-MAIN_IMG";
  const pMainArtwork = prepareACDItemForApi(metaDict[mainArtworkID]);

  let components = {};

  if (pTitleItem != null) {
    components.title = pTitleItem;
  }

  if (pSubtitleItem != null) {
    components.subtitle = pSubtitleItem;
  }

  if (pAuthorItem != null) {
    components.contributor = pAuthorItem;
  }

  if (pIntroItem != null) {
    components.intro = pIntroItem;
  }

  if (pMainArtwork != null) {
    components.main_image = pMainArtwork;
  }

  const pSections = contentACDItemList.map(anACDItem =>
    prepareACDItemForApi(anACDItem)
  );
  components.sections = pSections;

  /*console.log("send:");
  console.log(components);
  console.log("===");*/

  const uri =
    process.env.REACT_APP_API_ROOT + "articles/" + articleID + "/components";

  try {
    let response = await fetch(uri, {
      headers: { "Content-Type": "application/json" },
      method: "PUT",
      body: JSON.stringify({ components })
    });

    if (!response.ok) {
      toast.error(response.statusText);
      return;
    }

    let data = await response.json();

    return data;
  } catch (e) {
    console.log(e.toString());
  }
}
